import axios from 'axios'

/**
 * Generates an email template by sending the provided content to the server.
 *
 * @async
 * @function
 * @param {Object} params - The parameters for generating the email template.
 * @param {string} params.content - The content to include in the email template.
 * @returns {Promise<Object>} Resolves with the generated email template data.
 * @throws Will reject with an error message if no content is provided or if the request fails.
 */
export async function generateEmailTemplate(params) {
    const { content } = params

    try {
        if (!content || content.length === 0) {
            return Promise.reject('No content provided')
        }
        const { data } = await axios.post('/generate-newsletter', params, {
            headers: {
                Accept: 'text/html',
            },
        })
        return data
    } catch (error) {
        console.error('Error fetching email template:', error)
    }
}
